export default function handleAccordions(){
    $('body').on('click', '.js-toggle-accordion', function(){
        let $accordion = $(this);
        $accordion.parents('.accordion__item').toggleClass('accordion__item--active').find('.accordion__panel').slideToggle('fast');
    })
}
